import { PurchaseInvoiceToReview } from "api/trading-documents/models";
import { UUID } from "api/types";
import { DrawerRightPanel, RightPanelBody } from "components/utils/drawer";
import { ItemsSummarySection } from "pages/tradingDocuments/shared/components/rightPanel/itemsSummarySection/ItemsSummarySection";
import { CustomerInfoSection } from "./components/customerInfoSection/CustomerInfoSection";
import { GeneralInfoSection } from "./components/generalInfoSection/GeneralInfoSection";
import { PanelHeader } from "./components/PanelHeader";
import { TitleSection } from "./components/titleSection/TitleSection";
import styles from "./RightPanel.module.css";
import { CommentsGenericSection } from "components/common/commentsGeneric/CommentsGenericSection";
import { useRef } from "react";
import { useTradingDocument } from "api/trading-documents/hooks";
import { CommonError, MockupLoader } from "components/utils";

interface Props {
  tradingDocumentId: UUID;
  invoiceToReview: PurchaseInvoiceToReview;
}

export const RightPanel = ({ tradingDocumentId, invoiceToReview }: Props) => {
  const clearCommentsRef = useRef<HTMLDivElement>(null);
  const { data: tradingDocument, error, isLoading } = useTradingDocument(
    { id: tradingDocumentId },
    { enabled: Boolean(tradingDocumentId) },
  );

  if (error) {
    return (
      <DrawerRightPanel>
        <CommonError status={error._httpStatus_} />
      </DrawerRightPanel>
    );
  }

  if (isLoading) {
    return (
      <DrawerRightPanel>
        <MockupLoader type="drawer" />
      </DrawerRightPanel>
    );
  }

  if (!tradingDocument) return null;

  return (
    <DrawerRightPanel className={styles.widerDrawer} key={invoiceToReview.id}>
      <PanelHeader invoiceToReview={invoiceToReview} />
      <RightPanelBody myRef={clearCommentsRef} hasCommentsModule>
        <TitleSection invoice={invoiceToReview} />
        <GeneralInfoSection invoice={invoiceToReview} />
        <ItemsSummarySection
          enableAddingPosition={true}
          isPurchaseImport={true}
          showTransactionNumber={false}
          tradingDocument={tradingDocument}
        />
        <CustomerInfoSection invoice={invoiceToReview} />
      </RightPanelBody>
      <CommentsGenericSection
        outsideRef={clearCommentsRef}
        paramName="tradingDocument"
        endpointUrl="/finances/comments/items"
        commentedObject={invoiceToReview}
      />
    </DrawerRightPanel>
  );
};
